import React from "react";
import "./trait1.css";

const Trait1 = ({ traitValue, traitTitle, traitCardImg, bgColor }) => {
  return (
    <div className="trait-card1" style={{background: bgColor}}>
      <div className="trait-card1-info">
        <h1>{traitValue}</h1>
        <h2>{traitTitle}</h2>
      </div>
      <img src={traitCardImg} alt="traitCardImg" />
    </div>
  );
};

export default Trait1;
